export class ServerException extends Error {
  constructor({ statusCode, message, ...res }) {
    super(message);

    this.message = message || "An unknown error occurred";
    this.status = statusCode || 520;
    this.response = res;
  }

  status;

  message;

  toString() {
    return `${this.status}: ${this.message}`;
  }
}
